import {Pill} from '@wandb/components';
import React, {useCallback} from 'react';
import {type Descendant, type Editor} from 'slate';
import {Editable, type RenderElementProps, Slate} from 'slate-react';

export const WBAgentEditor = ({
  editor,
  initialValue,
  onChange,
  onKeyDown,
}: {
  editor: Editor;
  initialValue: Descendant[];
  onChange: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}) => {
  const renderElement = useCallback(
    (props: RenderElementProps) => <Element {...props} />,
    []
  );
  return (
    <Slate editor={editor} initialValue={initialValue} onChange={onChange}>
      <Editable
        renderElement={renderElement}
        placeholder="Ask the W&B Agent"
        spellCheck
        autoFocus
        onKeyDown={onKeyDown}
        className="outline-none max-h-[180px] overflow-y-auto overscroll-none [scrollbar-color:#0d0f1252_transparent]"
      />
    </Slate>
  );
};

const Element = ({attributes, children, element}: RenderElementProps) => {
  if (element.type === 'run-mention') {
    return (
      <span {...attributes} contentEditable={false} className="align-middle">
        <Pill icon="running-repeat" textValue={element.displayName} />
        <span style={{display: 'none'}}>{children}</span>
      </span>
    );
  }
  return <div {...attributes}>{children}</div>;
};
